import React,{useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box, Tooltip} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
        height:'4.1rem',
        width:290,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card2:{
        height:'4.1rem',
        width:240,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
       // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
      },
    card3:{
        height:'4.1rem',
        width:240,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        //marginTop:'-.1rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600
    },
    subtitulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.8rem',
    },
    subtituloCard:{
       // color:'#4a4a4a',
        textAlign:'center',
        marginTop:'.1rem',
        fontSize:'.9rem',
    },
}));


export default function CardPreguntas({valor}){
    const classes = useStyles();
    const[total,setTotal]= useState([])
    const auxTxt ="¿Votaría por (nuestro partido) ?"
    const auxTxt2 ="¿Conoce al candidato (nuestro) ?"
    const auxTxt3 ="¿Votaría por nuestro candidato?"
    const auxColor=process.env.REACT_APP_Fondo_Color
    React.useEffect(()=>{    
        const Preg01Indec = valor.Preg01Indec 
        const Preg03No = valor.Preg03No
        const Preg03Si = valor.Preg03Si
        const Preg01No = valor.Preg01No 
        const Preg01Si = valor.Preg01Si 
        const Preg02No = valor.Preg02No                       
        const Preg02Si = valor.Preg02Si        
        setTotal({
            Preg01Indec:Preg01Indec, Preg03No:Preg03No,
            Preg03Si:Preg03Si, Preg01No:Preg01No, 
            Preg02No:Preg02No, Preg01Si:Preg01Si, Preg02Si:Preg02Si,             
        })
     },[valor])   

    function generarCards1(mensaje,datGen,datTot, valor3, leyenda){
        return( 
        <CardContent>
            <div  style={{ textAlign:'center',  fontSize:'.8rem', marginBottom:".2rem", marginTop:"-.2rem" }} >             
             {'Indeciso '}         
                <NumberFormat value={valor3} displayType={'text'}  thousandSeparator={true}/>
                {' | Si '}
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                <span>{" | No "} <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/></span> 
            </div>
            <Tooltip title={leyenda}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }

    function generarCards3(mensaje,datGen,datTot, leyenda){
        return( 
        <CardContent>
            <div  style={{ textAlign:'center', fontSize:'.8rem', marginBottom:".2rem", marginTop:"-.2rem" }} >             
                {"Si "}
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' | No '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>                
            </div>
            <Tooltip title={leyenda}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }
    return (         
    <Box display="flex" flexDirection="row" mb={1}  >   
        <Box display="flex" flexDirection="row">                                    
            <Card className={classes.card}>
                {generarCards1('Pregunta 1', total.Preg01Indec, total.Preg01Si, total.Preg01No, auxTxt)}
            </Card>
            <Card className={classes.card3}>
                {generarCards3('Pregunta 2', total.Preg02Si, total.Preg02No, auxTxt2)}
            </Card>
             <Card className={classes.card3}>
                {generarCards3('Pregunta 3', total.Preg03Si ,total.Preg03No, auxTxt3)}
            </Card>
        </Box>   
    </Box>
    );
}
 